import { createSlice } from "@reduxjs/toolkit"
import { ShopperInsightsSearchHitCheckout, ShopperInsightsSearchHitSession } from "lib/types/generated/graphql"

const initialStateValue = {
  email: "",
  orders: undefined,
  checkouts: [] as ShopperInsightsSearchHitCheckout[],
  sessions: [] as ShopperInsightsSearchHitSession[]
}

const slice = createSlice({
  name: "customer",
  initialState: initialStateValue,
  reducers: {
    setCustomerEmail: (state = initialStateValue, action) => {
      state.email = action.payload
    },
    setCustomerOrders: (state = initialStateValue, action) => {
      state.orders = action.payload
    },
    setCustomerCheckouts: (state = initialStateValue, action) => {
      state.checkouts = action.payload
    },
    setCustomerSessions: (state = initialStateValue, action) => {
      state.sessions = action.payload
    },
    clearCustomerData: (state = initialStateValue) => {
      state.email = ""
      state.orders = undefined
      state.checkouts = []
      state.sessions = []
    }
  }
})

const { actions, reducer } = slice
export const { setCustomerEmail, setCustomerOrders, setCustomerCheckouts, setCustomerSessions, clearCustomerData } = actions

export default reducer
